import styled from 'styled-components/macro';
// import { motion } from 'framer-motion';
// import theme from '../../styles/GlobalTheme/schema.json';
import { defaultStyle } from '../../styles/GlobalTheme/GlobalStyles';
import px2vw from '../../utils/px2vw';

export const Items = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    @media only screen and (max-width: 425px) {
        flex-direction: column;
    }
`;

export const Item = styled.div`
    display: flex;
    flex-direction: row;
    margin-top: 47px;
    align-items: center;

    @media only screen and (max-width: 425px) {
        margin-top: 10px;
        flex-direction: row;
        align-items: center;
    }
`;

export const ItemIcon = styled.img`
    height: 100px;
    width: 100px;
    margin-right: ${px2vw(59)};
    @media only screen and (max-width: 425px) {
        height: 80px;
        width: 80px;
    }

    @media only screen and (max-width: 768px) {
        height: 80px;
        width: 80px;
    }
`;

export const ItemTitle = styled.h3`
    font-family: ${props => props.theme.fontFamily};
    font-style: normal;
    font-weight: 600;
    font-size: ${props => props.theme.subHeaderFontSize};
    line-height: 24px;
    color: #E32C5E;
`;

export const ItemText = styled.p`
    font-family: ${props => props.theme.fontFamily};
    font-style: normal;
    font-weight: 600;
    color: ${props => props.fontColor || 'black'};
    font-size: 16px;
    line-height: 24px;
    max-width: ${px2vw(752)};
    margin-top: 25.35px;

    @media only screen and (max-width: 425px) {
        margin-top: 5px;
        margin: auto;
        /* margin-left: 10px; */
        max-width: 100%;
        font-size: 12px;
        line-height: 18px;
    }

    @media only screen and (max-width: 768px) {
        font-size: 14px;
        line-height: 18px;
        margin-top: 5px;
    }
`;

export const Title = styled.h3`
    font-family: ${props => props.theme.fontFamily};
    font-style: normal;
    font-weight: 600;
    font-size: 32px;
    line-height: 60px;
    color: #000000;

    @media only screen and (max-width: 425px) {
        font-size: 16px;
    }
`;
export const Text = styled.p`
    font-family: ${props => props.theme.fontFamily};
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 24px;
    color: #000000;

    @media only screen and (max-width: 425px) {
        font-size: 14px;
        line-height: 20px;
    }
`;